import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { TokenService } from '../../local/token/token.service';
import { environment } from '../../../../environments/environment';
import * as signalR from '@microsoft/signalr';
import * as moment from 'moment';
import { LocalStorageService } from 'ngx-webstorage';
import { BroadcasterService } from '../../local/broadcaster/broadcaster.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export const NotificationEvents = {
  messageReceived: 'message-received',
  commandCompleted: 'command-completed',
  errorReceived: 'error-received',
  caseOpened: 'case-opened',
  caseClosed: 'case-closed',
  openedCases: 'opened-cases',
  appUpdated: 'app-updated',
  incidentMessage: 'incident-message'
};

@Injectable()
export class WebsocketService {
  socketUrl = environment.webSocketUrlCqrs;
  socketConnectionStatus = '';
  socketErrorMsg = false;
  connectionRetries = 0;
  commandCompletedEvents = [];
  linaConnection: signalR.HubConnection = null;
  linaNoAuthConnection: signalR.HubConnection = null;
  lastError = null;
  hubProxy;

  constructor(
    private tokenService: TokenService,
    private storage: LocalStorageService,
    private broadcastService: BroadcasterService,
    private snackBar: MatSnackBar,
    private translate: TranslateService) {
  }

  private setupLinaNoAuthConnection() {

    this.linaNoAuthConnection = this.commonSetup(this.socketUrl + '/notify');

    this.linaNoAuthConnection.on('SendIncidentMessage', message => {
      console.log('Incomming socket (SendIncidentMessage): ', message, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.incidentMessage, message);
    });

    this.linaNoAuthConnection.on('commandCompleted', event => {
      console.log('Incomming socket (CommandCompleted): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.commandCompleted, event);

      this.commandCompletedEvents.unshift(event.CorrelationId);
      if (this.commandCompletedEvents.length > 10) {
        this.commandCompletedEvents.length = 10;
      }
      // console.log('Current commandCompleted array: ', this.commandCompletedEvents);
    });

    this.linaNoAuthConnection.start()
      .then(() => {
        this.socketConnectionStatus = 'CONNECTED_NOAUTH';
        this.connectionRetries = 0;
        if (this.socketErrorMsg) {
          this.socketConnected();
        }
        this.logActivity();
      }, (err => {
        console.log('Could not connect', err);
      }));
  }

  private setupConnection() {

    // Setup
    this.linaConnection = this.commonSetup(this.socketUrl + '/signalr?token=' + this.tokenService.getAccessToken());

    // Listeners
    this.linaConnection.on('commandCompleted', event => {
      console.log('Incomming socket (CommandCompleted): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.commandCompleted, event);

      this.commandCompletedEvents.unshift(event.CorrelationId);
      if (this.commandCompletedEvents.length > 10) {
        this.commandCompletedEvents.length = 10;
      }
      // console.log('Current commandCompleted array: ', this.commandCompletedEvents);
    });

    this.linaConnection.on('SendIncidentMessage', message => {
      // console.log('Incomming socket (SendIncidentMessage): ', message, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.incidentMessage, message);
    });

    this.linaConnection.on('message', event => {
      // console.log('Incomming socket (message): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.messageReceived, event);
    });

    this.linaConnection.on('error', event => {
      // console.log('Incomming socket (error): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.errorReceived, event);
    });

    this.linaConnection.on('caseOpened', (caseId, userName, caseList) => {
      // console.log('Incomming socket (caseOpened): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.caseOpened, { caseId: caseId, userName: userName, caseList: caseList });
    });

    this.linaConnection.on('caseClosed', (caseId, userName, caseList) => {
      // console.log('Incomming socket (caseClosed): ', event, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.caseClosed, { caseId: caseId, userName: userName, caseList: caseList });
    });

    this.linaConnection.on('openedCases', caseList => {
      // console.log('Incomming socket (openedCases): ', caseList, ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.openedCases, { caseList: caseList });
    });

    this.linaConnection.on('appUpdated', () => {
      console.log('Incomming socket (applicationUpdated): ', ' Time: ', moment().format('HH:mm:ss.SS'));
      this.broadcastService.broadcast(NotificationEvents.appUpdated);
    });

    // State changes
    /*this.linaConnection.stateChanged(state => {
      switch (state.newState) {
        case signalR.HubConnectionState.Connecting:
          this.socketConnectionStatus = 'CONNECTING';
          break;
        case signalR.HubConnectionState.Connected:
          this.socketConnectionStatus = 'CONNECTED';
          this.connectionRetries = 0;
          if (this.socketErrorMsg) {
            this.socketConnected();
          }
          break;
        case signalR.HubConnectionState.Reconnecting:
          this.socketConnectionStatus = 'RECONNECTING';
          break;
        case signalR.HubConnectionState.Disconnected:
          this.socketConnectionStatus = 'DISCONNECTED';
          const lastActivity = this.storage.retrieve('lastActivity');

          if (!this.socketErrorMsg && (lastActivity && moment().diff(moment(lastActivity), 'minutes') > 30)) {
            this.socketDisconnected();
          }

          if (this.tokenService.getAccessToken() && this.connectionRetries < 1 && this.linaConnection !== null) {
            this.connectionRetries++;
            setTimeout(() => {
              console.log('Trying to reconnect/re-init');
              this.setupConnection();
            }, 5000);
          }
          // console.log('Last error:', this.lastError, ' Time:', moment().format('HH:mm:ss.SS'));
          break;
      }
      console.log('Websocket connection changed state:',
        state, 'New status:',
        this.socketConnectionStatus,
        ' Time:',
        moment().format('HH:mm:ss.SS'));
    });*/

    // setup connection
    this.linaConnection.start()
      .then(() => {
        this.socketConnectionStatus = 'CONNECTED';
        this.connectionRetries = 0;
        if (this.socketErrorMsg) {
          this.socketConnected();
        }
        this.logActivity();
      }, (err => {
        console.log('Could not connect', err);
      }));
  }

  private logActivity() {
    console.log('Websocket connection changed state to: ',
      this.socketConnectionStatus,
      ' Time:',
      moment().format('HH:mm:ss.SS'));
  }

  private socketConnected() {
    if (this.socketErrorMsg) {
      this.socketErrorMsg = false;
      this.snackBar.open(this.translate.instant('SOCKET_CONNECTED'), '', {
        duration: 3000,
      });
    }
  }

  private socketDisconnected() {
    this.socketErrorMsg = true;

    const failedSnackBar = this.snackBar.open(this.translate.instant('SOCKET_FAILED'), this.translate.instant('RELOAD'), {
      duration: 0
    });

    failedSnackBar.onAction().subscribe(() => {
      window.location.reload();
    });
  }


  private commonSetup(url: string) {

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect([2000, 30000, 60000, 120000, 240000])
      .build();

    connection.onclose(error => {
      if (error) {
        this.lastError = error;
        console.warn(error);
      }

      this.socketConnectionStatus = 'DISCONNECTED';
      this.logActivity();
      const lastActivity = this.storage.retrieve('lastActivity');

      if (!this.socketErrorMsg && (lastActivity && moment().diff(moment(lastActivity), 'minutes') > 30)) {
        this.socketDisconnected();
      }

      if (this.tokenService.getAccessToken() && this.connectionRetries < 1 && connection !== null) {
        this.connectionRetries++;
        setTimeout(() => {
          console.log('Trying to reconnect/re-init');
          this.setupConnection();
        }, 5000);
      }
    });

    connection.onreconnecting(error => {
      this.socketConnectionStatus = 'RECONNECTING';
      this.logActivity();
    });

    connection.onreconnected(connectionId => {
      this.socketConnectionStatus = 'CONNECTED';
      this.logActivity();
      this.connectionRetries = 0;
      if (this.socketErrorMsg) {
        this.socketConnected();
      }
    });

    return connection;
  }

  // Public methods
  initService() {
    if (this.linaNoAuthConnection) {
      this.cancelService(this.linaNoAuthConnection);
    }
    const self = this;
    if ((this.socketConnectionStatus === '' || this.socketConnectionStatus === 'DISCONNECTED')) {
      this.socketConnectionStatus = 'INITIALIZED';
      this.setupConnection();
      this.socketErrorMsg = false;
    }
  }

  initNoAuthService() {

    if (this.linaConnection) {
      this.cancelService(this.linaConnection);
    }

    this.setupLinaNoAuthConnection();
  }

  cancelService(connection: signalR.HubConnection) {
    if (connection) {
      this.socketErrorMsg = true;
      connection.stop();
      connection = null;
    }
  }

  isConnected() {
    return (this.socketConnectionStatus === 'CONNECTED');
  }

  waitForCompletion(id) {

    // console.log('Starting to wait for socket regarding: ', id, ' Time: ', moment().format('HH:mm:ss.SS'));
    // console.log('Socket connection status: ', this.socketConnectionStatus, ' Time: ', moment().format('HH:mm:ss.SS'));
    return new Observable(observer => {

      let socketTimeout;
      if (this.socketConnectionStatus !== 'CONNECTED' || this.linaConnection === null) {
        // console.log('Socket not connected, trying to connect: ', ' Time: ', moment().format('HH:mm:ss.SS'));

        if (this.linaNoAuthConnection !== null) {
          this.setupLinaNoAuthConnection();
        } else {
          this.setupConnection();
        }

        socketTimeout = setTimeout(() => {
          observer.next(false);
          observer.complete();
          // socketListener();
        }, 8000);
      } else {
        socketTimeout = setTimeout(() => {
          observer.next(false);
          observer.complete();
          // socketListener();
        }, 30000);
      }

      const socketListener = this.broadcastService.on(NotificationEvents.commandCompleted).subscribe(event => {
        /*console.log('Command completed listener. Waiting for: ',
          id, '. Got: ', event.CorrelationId, ' Time: ', moment().format('HH:mm:ss.SS'));*/
        if (event.CorrelationId === id) {
          clearTimeout(socketTimeout);
          observer.next(true);
          observer.complete();
          // socketListener();
        }

      });

      this.commandCompletedEvents.filter(event => {
        if (event === id) {
          /*console.log('Found event in Command completed array. Looking for: ',
          id, '. Found: ', event, ' Time: ', moment().format('HH:mm:ss.SS'));*/
          clearTimeout(socketTimeout);
          observer.next(true);
          observer.complete();
          // socketListener();
        }
      });

    });
  }
  caseOpened(caseId) {
    this.linaConnection.send('OpenCase', caseId).then();
  }
  caseClosed(caseId) {
    this.linaConnection.send('CloseCase', caseId).then();
  }
  getOpenCases() {
    this.linaConnection.send('GetOpenCases').then();
  }
}

@NgModule({
  imports: [],
  declarations: [],
  exports: []
})
export class WebsocketModule {
  static forRoot(): ModuleWithProviders<WebsocketModule> {
    return {
      ngModule: WebsocketModule,
      providers: [WebsocketService]
    };
  }
}
